import React from "react";
import RegisterMemberUnselect from "../../assets/images/register/register-member-unselect.png";
import RegisterMemberSelected from "../../assets/images/register/register-member-selected.png";
import RegisterShopUnselect from "../../assets/images/register/register-shop-unselect.png";
import RegisterShopSelected from "../../assets/images/register/register-shop-selected.png";
import { useNavigate } from 'react-router-dom'
import { Drawer } from '@mui/material';
import TopBanner from '../../components/layout/TopBanner';

import Cookies from '../../components/text/CookiesGreen';
import { SearchRegister } from '../../services/Register'
import { useDispatch, useSelector } from 'react-redux';
import { setRegisterMain } from '../../features/register/RegisterMainSlice';
import { useLiff } from 'react-liff';
import TopLogo from '../../components/layout/TopLogo';
import TopLogoCat from '../../components/layout/TopLogoCat';

import registerCat from '../../assets/images/register/register-cat-p2.png';
import PrimaryGreenButton from "../../components/button/PrimaryGreenButton";
import registerBanner from '../../assets/images/register/banner-for-cat-p2.png';
import registerStep1 from '../../assets/images/register/step1-2.svg';
import SecondaryGreenButton from "../../components/button/SecondaryGreenButton";
import ConditionDialogGreen from "../../components/dialog/ConditionDialogGreen";
import CheckMemberGreenPopup from "../../components/popup/CheckMemberGreenPopup";

export default function RegisterMainCat() {
  const store = useSelector((state) => state.registerMain)
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [openCheckPopup, setOpenCheckPopup] = React.useState(false);

  // lineId
  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  React.useEffect(() => {
    if (localStorage.getItem('allow_cookie_cat')) {
      setOpenCheckPopup(true)
    }
    getSearchRegister();
  }, []);

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setRegisterMain(tmpObj));
  }

  async function getSearchRegister() {
    try {
      if (store['active'] === 0) {
        onClickImage(1);
      }
      const species = 2
      const { data } = await SearchRegister({ params: { lineId, species } })
      if (+data['resultCode'] === 20000) {
        const body = data.body || {};
        console.log('body', body);
        if (body['memberId']) {
          navigate('/catbook')
        } else if (body['employeeId'] && body['clinicPetShopId']) {
          // go MemberCardOwner
          navigate('/member-card-owner')
        }
      } else {

      }
    } catch (error) {
      console.log('getSearchRegister error', error)
    }

  }

  function onClickLinkCookie() {
    fnSetData('openCookieDialog', true);
  }

  function onClickNext() {
    if (checkAllowCookie()) {
      navigate('/register-cat-owner')
    } else {
      fnSetData('openCookieDrawer', true);
    }

  }

  function checkAllowCookie() {
    let allowCookie;
    const allowCookieStorage = localStorage.getItem('allow_cookie_cat')
    allowCookie = allowCookieStorage === 'true';
    return allowCookie;
  }

  function fnSetActiveImage(active) {
    if (active === 1) {
      fnSetData('imageList', [RegisterMemberSelected, RegisterShopUnselect]);
      fnSetData('textColorList', ['text-blue', 'text-gray']);
    } else if (active === 2) {
      fnSetData('imageList', [RegisterMemberUnselect, RegisterShopSelected]);
      fnSetData('textColorList', ['text-gray', 'text-blue']);
    } else {
      fnSetData('imageList', [RegisterMemberUnselect, RegisterShopUnselect]);
      fnSetData('textColorList', ['text-gray', 'text-gray']);
    }
  }

  function onClickImage(active) {
    fnSetData('active', active);
    if (checkAllowCookie()) {
      fnSetActiveImage(active)
    } else {
      // show popup allow cookie
      fnSetData('openCookieDrawer', true);
    }
  }

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    fnSetData('openCookieDrawer', open);
  };

  const toggleCookieDialog = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    fnSetData('openCookieDrawer', open);
  };

  function onOk(e) {
    console.log('on ok', e)
    localStorage.setItem('allow_cookie_cat', 'true');
    fnSetData('openCookieDialog', false);
    fnSetData('openCookieDrawer', false);
    fnSetActiveImage(store['active']);
    setOpenCheckPopup(true)
  }

  function onCancel(e) {
    console.log('on cancel', e)
    fnSetData('openCookieDialog', false);
    fnSetData('openCookieDrawer', false);
  }

  function onDrawerOk(e) {
    console.log('on onDrawerOk', e)
    localStorage.setItem('allow_cookie_cat', 'true');
    fnSetData('openCookieDrawer', false);
    fnSetActiveImage(store['active'])
    setOpenCheckPopup(true)
  }

  function onDrawerCancel(e) {
    console.log('on onDrawerOk', e)
    fnSetData('openCookieDrawer', false);
  }

  return (
    <>
      <TopLogoCat />
      <TopBanner type="catRegister" />
      <div id="register-main">
        <img id="registerBanner" src={registerBanner} alt="registerBanner" />
        <img src={registerStep1} alt="registerStep1" className="w-[16%] mx-auto mt-[-10px]" style={{ display: "block" }} />
        <div className="text-[30px] text-center py-[30px]">
          ลงทะเบียนสำหรับ
        </div>
        <div className="justify-items-stretch text-center">
          <div>
            <img
              src={registerCat}
              className="w-[40%] mx-auto"
              alt="register-member-unselect"
            // onClick={() => onClickImage(1)}
            />
            <div className="text-[28px] text-green">เจ้าของน้องแมว</div>
          </div>
        </div>
        <div className="text-center pt-[50px] pb-[30px]">
          <PrimaryGreenButton variant="contained" onClick={onClickNext}>
            ถัดไป
          </PrimaryGreenButton>
        </div>
      </div>
      <div className="footer">
        <div className="p-[10px] leading-[100%]">
          <p>
            Copyright © 2021 Boehringer Ingelheim Animal Health (Thailand) Ltd.
            All rights reserved. Use of this Site is subject to the Terms of Use
            and Privacy Statement.
          </p>
          <hr className="text-gray my-2" />
          <p style={{ color: "gray" }}>
            This website is intended for residents of Thailand. The contents of
            this website are for information purposes only and are not intended
            to substitute for advice, treatment or recommendations of a
            veterinarian or healthcare professional. For questions about
            symptoms, treatment or medication, consult an appropriate veterinary
            or medical professional.
          </p>
        </div>
      </div>

      {/*Drawer Allow Cookie*/}
      <Drawer
        anchor="bottom"
        open={store['openCookieDrawer']}
        onClose={toggleDrawer(false)}
      >
        <div className="p-4">
          <div>
            เราใช้คุกกี้เพื่อเพิ่มประสบการณ์ที่ดีของผู้ใช้และวิเคราะห์การเข้าถึง เมื่อท่านกด ‘ยอมรับ’
            ถือว่าท่านยินยอมในการใช้
            <span className="text-green" onClick={onClickLinkCookie}>
              นโยบายการใช้คุกกี้
            </span>
            ของเราแล้ว
          </div>
          <br />
          <div className="flex flex-row place-content-end gap-1">
            <PrimaryGreenButton variant="contained" onClick={onDrawerOk}>
              ยอมรับ
            </PrimaryGreenButton>
            <SecondaryGreenButton variant="outlined" onClick={onDrawerCancel}>
              ไม่ยอมรับ
            </SecondaryGreenButton>
          </div>
        </div>
      </Drawer>

      {/*Dialog Cookie*/}
      <ConditionDialogGreen title="นโยบายการใช้คุกกี้" open={store['openCookieDialog']} toggle={toggleCookieDialog}
        onOk={onOk}
        onCancel={onCancel}>
        <Cookies />
      </ConditionDialogGreen>

      <CheckMemberGreenPopup
        actionFunction={() => {
          setOpenCheckPopup(false);
        }}
        open={openCheckPopup}
        onClose={() => {
          setOpenCheckPopup(false);
        }}>
      </CheckMemberGreenPopup>
    </>
  );
}